import * as LinkService_en from './LinkService.en.js';
import * as LinkService_es from './LinkService.es.js';

const LinkServiceTuple = [
  { type: 'LinkService', language: 'en', object: LinkService_en.default },
  { type: 'LinkService', language: 'es', object: LinkService_es.default },
];

export default LinkServiceTuple;
